/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {
	BaseComponent,
	DialogModule
} from "@intuitionrobotics/thunderstorm/frontend";
import {DialogCard, showDialog} from "../../widget/DialogCard";
import React from "react";
import {
	CommentsModule,
	OnCommentDeleted
} from "@modules/CommentsModule";
import {FONTS} from "@res/fonts";

type Props = {
	commentId: string
}

type State = {
	loading: boolean
}

export class DeleteComment
	extends BaseComponent<Props, State>
  implements OnCommentDeleted {

	constructor(props: Props) {
		super(props);
		this.state = {
			loading: false
		};
	}

	__onCommentDeleted = () => DialogModule.close();

	public static show(commentId: string) {
		return showDialog(
			<DeleteComment commentId={commentId}/>
		);
	}

	private renderText() {
		return <div>
			{FONTS.reg_16_secondary_dark(`You are about to delete your comment`)}
			{FONTS.reg_16_secondary_dark(`Once you delete it, it’s gone for good.`)}
		</div>
	}

	render() {
		return <DialogCard
			style={{width: 500}}
			showX={true}
			title={"Delete Comment"}
			content={this.renderText()}
			saveLabel={"Delete"}
			cancelLabel={"Cancel"}
			onSave={() => {
				this.setState(
					{loading: true},
					async () => await CommentsModule.delete(this.props.commentId));
				return true;
			}}
			loading={this.state.loading}
		/>;
	}

}
